module.exports = __webpack_public_path__ + "img/5.3cd68d5.png";